/** 2026-10-26：扫码会话不可使用可预测的时间戳。 */
export function createWechatLoginState(){
  const values=new Uint8Array(16);globalThis.crypto.getRandomValues(values)
  return Array.from(values,value=>value.toString(16).padStart(2,'0')).join('')
}
